/**
 * TabNavigation - Tab导航组件
 * 用于GDS追溯页面的信息分类展示
 */

import React, { useState } from 'react';
import { Box, FactoryBuilding, CheckOne, Info, ShoppingBag, Truck, Certificate } from '@icon-park/react';
import './TabNavigation.css';

// 图标名称到组件的映射
const iconMap = {
  box: Box,
  factory: FactoryBuilding,
  check: CheckOne,
  info: Info,
  product: ShoppingBag,
  shipping: Truck,
  cert: Certificate,
};

// 获取图标组件
const getIconComponent = (iconName) => {
  if (!iconName) return null;

  // 如果已经是 React 元素，直接返回
  if (React.isValidElement(iconName)) {
    return iconName;
  }

  // 如果是字符串，查找对应的图标组件
  if (typeof iconName === 'string') {
    const IconComponent = iconMap[iconName.toLowerCase()];
    if (IconComponent) {
      return <IconComponent theme="outline" size={16} fill="currentColor" strokeWidth={3} />;
    }
  }

  return null;
};

function TabNavigation({ tabs = [], defaultActiveKey = 0 }) {
  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  if (!tabs || tabs.length === 0) {
    return <div className="tab-navigation-empty">暂无内容</div>;
  }

  return (
    <div className="tab-navigation-container">
      {/* Tab标签栏 */}
      <div className="tab-navigation-header">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-navigation-item ${activeKey === index ? 'active' : ''}`}
            onClick={() => setActiveKey(index)}
          >
            {tab.icon && <span className="tab-icon">{getIconComponent(tab.icon)}</span>}
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab内容区 */}
      <div className="tab-navigation-content">
        {tabs[activeKey] && tabs[activeKey].content}
      </div>
    </div>
  );
}

export default TabNavigation;

